import { C as ConstantsImpl } from './constants-oDhF27qL.js';
import { P as ProgramHeapImpl } from './program-CcLlGnAU.js';

function artifacts() {
  return {
    constants: new ConstantsImpl(),
    heap: new ProgramHeapImpl()
  };
}

export { artifacts as a };
